// The one rule behind every automatic refresh or reload of the /live page: never pull a video out
// from under a viewer still watching it. A web <video> says whether it is playing. Inside the native
// shell the bridge player (a media--bridge--* controller) plays natively and reports nothing back,
// so while one is mounted the page counts as playing and never refreshes itself away from it.
const BRIDGE_PLAYER = '[data-controller^="media--bridge--"]';

// Spread over which a whole crowd re-fetches the full /live page for one broadcast change (stream
// end, schedule change, room open, handoff, cable refresh). One shared window keeps the herd at a
// rate the fleet can render; go-live alone is lighter (a stage frame) and has its own, shorter one.
export const CROWD_REFRESH_SPREAD_MS = 60000;

// Runs callback({ waited }) once nothing is playing: right away (waited: false), or when the web
// video pauses or ends (waited: true), whichever of the two comes first. Returns a function that
// cancels the wait, or null when the callback has already run.
export function whenPlaybackStops(callback, root = document) {
  if (root.querySelector(BRIDGE_PLAYER)) return () => {};

  const video = root.querySelector("video");
  if (!video || video.paused || video.ended) {
    callback({ waited: false });
    return null;
  }

  const cancel = () => {
    video.removeEventListener("pause", onStop);
    video.removeEventListener("ended", onStop);
  };
  function onStop() {
    cancel();
    callback({ waited: true });
  }
  video.addEventListener("pause", onStop);
  video.addEventListener("ended", onStop);
  return cancel;
}
